import { render, staticRenderFns } from "./productTypeManage.vue?vue&type=template&id=78051fe9&scoped=true&"
import script from "./productTypeManage.vue?vue&type=script&lang=js&"
export * from "./productTypeManage.vue?vue&type=script&lang=js&"
import style0 from "./productTypeManage.vue?vue&type=style&index=0&id=78051fe9&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78051fe9",
  null
  
)

export default component.exports